import { useState, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { InputText } from '@/components/widget-components'
import { StableCoinValue, allTokenOptions } from '@/utils/currencies'
type TokensProps = {
  onSelectToken: (token: StableCoinValue) => void
}
export const Tokens = ({ onSelectToken }: TokensProps) => {
  const { t } = useTranslation()
  const [searchText, setSearchText] = useState('')
  const filteredOptions = useMemo(() => {
    try {
      return allTokenOptions.filter((tokenOption) => {
        return tokenOption.name.includes(searchText.toUpperCase())
      })
    } catch (e) {
      return []
    }
  }, [searchText])
  return (
    <div data-testid="btn-tokens-submit">
      {/* <div className="uppercase text-xl font-normal">Tokens</div> */}
      <InputText
        placeholder={t('tokens.search.placeholder')}
        onChange={(e) => setSearchText(e.target.value)}
        value={searchText}
        data-testid="btn-tokens-submit"
      />
      <div
        className="flex flex-col items-start mt-2"
        data-testid="btn-tokens-submit"
      >
        {filteredOptions.reverse().map((option) => {
          return (
            // <Dialog.Close key={option.value} asChild>
            <div
              onClick={() => onSelectToken(option.value)}
              className="p-4 hover:border-px hover:bg-slate-200 hover:text-black dark:hover:text-black"
              data-testid={`token-option-${option.value.toLowerCase()}`}
            >
              <div className="flex gap-1 justify-center items-center">
                <span
                  style={{
                    pointerEvents: 'none',
                  }}
                >
                  <div className="flex md:w-[16rem]">
                    {option.image && (
                      <div className="mr-1 md:mr-2">
                        <img
                          src={option.image}
                          height={20}
                          width={20}
                          data-testid={`token-image-${option.value.toLowerCase()}`}
                        />
                      </div>
                    )}
                    <div
                      className="text-left flex flex-col justify-center"
                      data-testid={`token-name-${option.value.toLowerCase()}`}
                    >
                      {option.name}
                    </div>
                  </div>
                </span>
                <span>
                  <svg
                    width="15"
                    height="15"
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    data-testid={`token-arrow-${option.value.toLowerCase()}`}
                  >
                    <path
                      d="M6.1584 3.13508C6.35985 2.94621 6.67627 2.95642 6.86514 3.15788L10.6151 7.15788C10.7954 7.3502 10.7954 7.64949 10.6151 7.84182L6.86514 11.8418C6.67627 12.0433 6.35985 12.0535 6.1584 11.8646C5.95694 11.6757 5.94673 11.3593 6.1356 11.1579L9.565 7.49985L6.1356 3.84182C5.94673 3.64036 5.95694 3.32394 6.1584 3.13508Z"
                      fill="currentColor"
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                    ></path>
                  </svg>
                </span>
              </div>
            </div>
            // </Dialog.Close>
          )
        })}
      </div>
    </div>
  )
}

/*
POTENTIAL IMPROVEMENTS:
1. Accessibility: Add keyboard navigation for better accessibility
2. Empty state: Show a message when no tokens are found
3. Performance: Virtualize the list for better performance with large token lists
4. Search experience: Add fuzzy search for better matching
5. Grouping: Group tokens by category or network
6. Favorites: Allow users to mark favorite tokens
7. Layout: Improve the responsive design for different screen sizes
8. Error handling: Add error states for failed API calls

Code suggestions (not to be implemented now):
1. Change SVG attributes from kebab-case (fill-rule, clip-rule) to camelCase (fillRule, clipRule) for React JSX
2. Add key props to list items for better React reconciliation
3. Add alt attributes to images for better accessibility
*/
